<template>
  <div class="legacy-mail-view">
    <v-card flat class="legacy-mail-content"><ai-mail class="legacy-mail-panel" /></v-card>
    <aside class="mail-version-banner" aria-label="Neue Mailansicht">
      <p>Die neue Mailansicht ist da.</p>
      <router-link to="/ai/mails" class="mail-version-link">Zur neuen Version <v-icon aria-hidden="true">mdi-arrow-right</v-icon></router-link>
    </aside>
  </div>
</template>

<script>
import aiMail from "@/components/ai/aiMail.vue"

export default {
  components: {
    aiMail,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>

<style scoped>
.legacy-mail-view { display: flex; flex-direction: column; height: 100vh; height: 100dvh; min-height: 20rem; background: #000; }
.legacy-mail-content { flex: 1; min-height: 0; overflow: hidden; }
.legacy-mail-panel { height: 100% !important; }
.mail-version-banner { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; flex-shrink: 0; gap: .65rem 1.5rem; padding: .75rem 1rem; padding-bottom: calc(.75rem + env(safe-area-inset-bottom, 0px)); background: #10251c; border-top: 1px solid #294334; color: #e6f1e8; }
.mail-version-banner p { margin: 0; font-size: 1rem; line-height: 1.5; }
.mail-version-link { display: inline-flex; align-items: center; justify-content: center; gap: .5rem; min-height: 2.75rem; padding: .6rem 1rem; border-radius: .65rem; background: #d4efbe; color: #163921; text-decoration: none; font-size: .875rem; font-weight: 600; line-height: 1.4; }
.mail-version-link:hover { background: #e4f7d6; }
.mail-version-link:focus-visible { outline: 3px solid #fff; outline-offset: 3px; }
.mail-version-link .v-icon { color: inherit; font-size: 1.125rem; }
@media (max-width: 480px) { .mail-version-banner { justify-content: space-between; } .mail-version-banner p { font-size: .875rem; } }
</style>
